import texts from './texts.json';

const DEFAULT_ROW_HEIGHT = 100;

const MESSAGES_PER_USER_OPTIONS = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 30, label: '30' },
];

const DEFAULT_MESSAGES_PER_USER_SELECTED = MESSAGES_PER_USER_OPTIONS[0].value;

const CSV_HEADERS = [
  texts.columns.aiAugmentedText,
  texts.columns.sentMessages,
  texts.columns.percentChanged,
  texts.columns.date,
  texts.columns.langfuseUrl,
];

export {
  DEFAULT_ROW_HEIGHT,
  MESSAGES_PER_USER_OPTIONS,
  DEFAULT_MESSAGES_PER_USER_SELECTED,
  CSV_HEADERS,
};
